module.exports = __webpack_public_path__ + "f11e2a633f9d9e3783bcf0ba292d9063.png";